import {NgModule} from '@angular/core';

import {EventRoutingModule} from './event-routing.module';
import {EventComponent} from './event.component';
import {SharedModule} from "@biletix/shared/shared.module";
import {EventDetailResolver} from "@biletix/features/event/resolvers/event-detail.resolver";
import {EventPageStateService} from "@biletix/features/event/services/event-page-state.service";
import {PerformanceListComponent} from './components/performance-list/performance-list.component';
import {ListItemComponent} from "@biletix/features/event/components/performance-list/list-item/list-item.component";
import {EventPageTabMenuComponent} from "@biletix/features/event/components/performance-list/event-page-tab-menu/event-page-tab-menu.component";
// export function eventHttpLoaderFactory(http: HttpClient) {
//   return new TranslateHttpLoader(http, './assets/i18n/event/', '.json');
// }

@NgModule({
    declarations: [
        EventComponent,
        ListItemComponent,
        PerformanceListComponent,
        ListItemComponent,
        EventPageTabMenuComponent
    ],
    imports: [
        SharedModule,
        EventRoutingModule,
    ],
  providers: [
    EventDetailResolver,
    EventPageStateService
  ]
})
export class EventModule {
}
